import React from "react";
import { ResponsiveBar } from "@nivo/bar";
const scoreTypesName = {
    hole_in_one: "Hoyo en uno",
    birdie: "Birdie",
    eagle: "Eagle"
};
const ScoreTypesStatsGraphicView = ({ data }) => {
    const dataToResponsiveBarStructure = () => {
        const responsiveBarStructure = [];
        Object.values(data).map(({ scoreTypeKey, players }) => {
            const scoreType = {
                scoreType: scoreTypesName[scoreTypeKey]
            };
            const playerCounts = {};
            players.forEach(({ playerName }) => {
                if (!playerCounts[playerName]) {
                    playerCounts[playerName] = 0;
                }
                playerCounts[playerName]++;
            });
            Object.entries(playerCounts)
                .sort(([, a], [, b]) => b - a)
                .forEach(([playerName, count], index) => {
                const key = `${String(index).padStart(3, '0')}_${scoreTypeKey}_${playerName}`;
                scoreType[key] = count;
            });
            responsiveBarStructure.push(scoreType);
        });
        return responsiveBarStructure;
    };
    const responsiveBarKeys = () => {
        const allKeys = [];
        Object.values(data).forEach(({ scoreTypeKey, players }) => {
            const playerCounts = {};
            players.forEach(({ playerName }) => {
                if (!playerCounts[playerName]) {
                    playerCounts[playerName] = 0;
                }
                playerCounts[playerName]++;
            });
            Object.entries(playerCounts)
                .sort(([, a], [, b]) => b - a)
                .forEach(([playerName], index) => {
                const key = `${String(index).padStart(3, '0')}_${scoreTypeKey}_${playerName}`;
                if (!allKeys.includes(key)) {
                    allKeys.push(key);
                }
            });
        });
        return allKeys.sort();
    };
    const getPlayerNameFromKey = (key) => {
        const parts = key.split('_');
        return parts.slice(2).join('_');
    };
    return (React.createElement("div", { className: "responsiveBarContainer" },
        React.createElement(ResponsiveBar, { data: dataToResponsiveBarStructure(), keys: responsiveBarKeys(), indexBy: "scoreType", labelSkipWidth: 12, labelSkipHeight: 12, margin: {
                top: 50,
                right: 130,
                bottom: 50,
                left: 60
            }, legendLabel: (value) => getPlayerNameFromKey(value.id), tooltip: ({ id, value }) => (React.createElement("div", { style: {
                    padding: '5px 10px',
                    background: 'white',
                    border: '1px solid #ccc'
                } },
                React.createElement("strong", null, getPlayerNameFromKey(id)),
                ": ",
                value)) })));
};
export default ScoreTypesStatsGraphicView;
